export default "__VITE_ASSET__7c48d3df__"